// extracted by mini-css-extract-plugin
export default {"generalBoschFont":"\"boschsans\",sans-serif !important","snackbar-container":"ie-alert_snackbar-container__1kZPm","snackbar-content":"ie-alert_snackbar-content__jtH9p"};